import { FunnelConfig } from '~/utils/funnels';

export const config: FunnelConfig = {
  id: 'conference',
  path: '/conference',
  show: () => true,
};
